import { render, staticRenderFns } from "./CommandeTP.vue?vue&type=template&id=c90d917a&scoped=true"
import script from "./CommandeTP.vue?vue&type=script&lang=js"
export * from "./CommandeTP.vue?vue&type=script&lang=js"
import style0 from "./CommandeTP.vue?vue&type=style&index=0&id=c90d917a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90d917a",
  null
  
)

export default component.exports